import moment from 'moment-timezone';




export class Util {
    /**
     * Genera grupos de 4 caracteres aleatorios
     * @example getUniqueId(1) : 607f
     * @example getUniqueId(2) : 95ca-361a-f8a1-1e73
     */
    static getUniqueId(parts: number): string {
        const stringArr = [];
        for (let i = 0; i < parts; i++) {
            // tslint:disable-next-line:no-bitwise
            const S4 = (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
            stringArr.push(S4);
        }
        return stringArr.join('-');
    }

    static getFileExtention = (fileUrl: any) => {
        return /[.]/.exec(fileUrl) ?
            /[^.]+$/.exec(fileUrl) : undefined;
    }

    /**
     * 
     * @param fileUrl 
     * @param extention Booleano que le indicas si quieres que el nombre venga con extensión (.jpg, .png, etc)
     * @returns 
     */
    static getFileName = (fileUrl: string, extention = true) => {
        if (fileUrl && extention) {
            const last = fileUrl.lastIndexOf("/");
            return fileUrl.substring(last + 1);
        } else if (fileUrl && !extention) {
            const last = fileUrl.lastIndexOf("/");
            const pathAux = fileUrl.substring(last + 1);

            const atPosition = pathAux.lastIndexOf(".");
            return pathAux.substring(0, atPosition);

        } else {
            return fileUrl;
        }
    }


    static formatBytes(bytes: any, decimals = 2) {
        if (bytes === 0) return '0 Bytes';
        const k = 1024;
        const dm = decimals < 0 ? 0 : decimals;
        const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
        const i = Math.floor(Math.log(bytes) / Math.log(k));
        return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
    }

    static getLetterAvatar(name: string, surname?: string) {
        let letterAvatar = "";
        if (name && name != "") letterAvatar += name.substring(0, 1);
        if (surname && surname != "") {
            letterAvatar += surname.substring(0, 1);
        } else {
            letterAvatar += name.substring(1, 2);
        }

        return letterAvatar;
    }

    static getAge(date: any) {
        let original: any = new Date(date);
        if (original != "Invalid Date") {
            var today = new Date();
            var age = today.getFullYear() - original.getFullYear();
            var m = today.getMonth() - original.getMonth();
            if (m < 0 || (m === 0 && today.getDate() < original.getDate())) {
                age--;
            }
            return age;
        } else {
            return ""
        }
    }



    static isOdd(num: any) {
        return num % 2;
    }

    static monthStatement(date: any) {
        let d = new Date(date.replace(' ', 'T'))
        const month = ["ENE", "FEB", "MAR", "ABR", "MAY", "JUN", "JUL", "AGO", "SEP", "OCT", "NOV", "DIC"];
        return month[d.getMonth()];
    }

    static isLeapYear(year: any) {
        return (year % 400 === 0) ? true :
            (year % 100 === 0) ? false :
                year % 4 === 0;
    }


    /**
     * Indica si el peso es superior al del límite
     * @param limitMb peso en mb
     * @param sizebyte peso en bytes
     * @returns 
     */
    static isSizeBigger(limitMb: number, sizebyte: number) {
        const sizeMb = sizebyte / Math.pow(1024, 2);
        return sizeMb >= limitMb;
    }

    /**
     * Recorta un texto y agrega puntos suspensivos
     * @param value 
     * @param limit 
     * @returns 
     */
    static cutWord(value: string, limit = 0) {
        if (limit == 0 || limit < 0) return value;
        if (value && value.length > limit) {
            return value.substring(0, limit) + "..."
        } else {
            return value;
        }
    }

    static fixDecimal(value) {
        let number: number = parseInt(value);
        let isNumber = !isNaN(number);
        if (isNumber) {
            let numberString = parseFloat(value).toFixed(2);
            let index = numberString.indexOf('.');
            let substring = numberString.slice(index);
            return (substring == '.00') ? parseFloat(numberString.slice(0, index)) : parseFloat(numberString);
        } else {
            return 0;
        }
    }


    static random = (min, max) => Math.floor(Math.random() * (max - min + 1) + min)

    static capitalize(str) {
        if (str === undefined || str === null) return ""
        str = str.toLowerCase();
        return str.charAt(0).toUpperCase() + str.slice(1);
    }

    static transformStatusSubstepData(str) {
        if (str === undefined || str === null) return ""
        str = str.toLowerCase();
        return str.charAt(0).toUpperCase() + str.slice(1);
    }


    static delay(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }


    static downloadDocumentBackend = (url, filename) => {
        if (!url) {
            console.warn("No existe url");
            return;
        }
        const link = document.createElement('a');
        const urlApi = process.env.REACT_APP_API_URL_MS_AUTH;
        link.href = `${urlApi}${url}`;
        link.download = filename || 'document';
        link.target = '_blank';
        document.body.appendChild(link);
        link.click();
        link.remove();
    }

    // static correctDate = (date: any) => {
    //     const timezone = 'Europe/Madrid';
    //     const now = moment.tz(timezone);
    //     const offset = now.utcOffset(); 

    //     console.log("offset", offset);
    //     console.log("offset", offset);


    //     return moment.tz(date, timezone).startOf('day').add(offset, 'minutes').toDate()
    // }

    static correctDate = (date: any, endOfDay = false) => {
        const timezone = 'Europe/Madrid';

        // Inicia con la fecha/hora en la zona horaria especificada
        let correctedDate = moment.tz(date, timezone);

        // Ajusta al inicio o final del día según 'endOfDay'
        if (endOfDay) {
            // Para el final del día, ajusta a 23:59:59
            correctedDate = correctedDate.endOf('day');
        } else {
            // Para el inicio del día, ajusta a 00:00:00
            correctedDate = correctedDate.startOf('day');
        }

        // Retorna la fecha ajustada como un objeto Date
        return correctedDate.toDate();
    }


    static orderImagesByPosition = (imageList: {
        id?: number;
        name?: string;
        position?: number;
    }[]) => {
        if (!imageList) {
            return [];
        }
        return imageList.sort((a, b) => a.position - b.position);
    }

    static sleep = (ms) => {
        return new Promise(resolve => setTimeout(resolve, ms));
    }


    /**
 * Cuenta el total de elementos en un Record<number, any[]>
 * @param {Record<number, any[]>} record - El objeto Record a contar
 * @return {number} - El total de elementos
 */
    static countTotalItemsInRecord = (record) => {
        let totalItems = 0;
        Object.values(record).forEach((array: any) => {
            totalItems += array.length;
        });
        return totalItems;
    };


    static transformBlobToFile = async (blobFile, fileName: string) => {
        // Aquí deberías obtener tu blob. Por ejemplo, puede ser una respuesta de fetch.
        const blobUrl = blobFile;

        // Convertir la URL del blob en un blob
        const response = await fetch(blobUrl);
        const blob = await response.blob();

        // Crear un archivo a partir del blob
        const file = new File([blob], fileName, { type: blob.type });

        // console.log("que tipo de file es este", file)
        // console.log(JSON.stringify(blobFile, null, 2))

        // Actualizar el estado con el nuevo archivo
        return file;
    }
}


